export default __webpack_public_path__ + "static/media/InfillBasicImg.4b753c92.jpg";